export type LLMStreamedResponse = {
  content: string;
  isDone: boolean;
  conversationId: string;
};

export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant'
}

export type ChatMessage = {
  role: MessageRole;
  content: string;
};

export type ConversationParameter = {
  key: string;
  value: string | null;
};

export interface Conversation {
  title?: string;
  messages: ChatMessage[];
  type: 'FEEDBACK' | 'SIMULATION' | 'EMAIL_DRAFTER';
  parameters?: ConversationParameter[];
}

export enum SocketEvent {
  COACHING_CHAT_MESSAGE_STREAM = 'coaching-chat-message-stream',
  COACHING_CHAT_RESPONSE = 'coaching-chat-response'
}

export type SocketInputEvents = SocketEvent.COACHING_CHAT_MESSAGE_STREAM;
export type SocketOutputEvents = SocketEvent.COACHING_CHAT_RESPONSE;

export type ServerToClientEvents = {
  [SocketEvent.COACHING_CHAT_RESPONSE]: (llmResponse: LLMStreamedResponse) => void;
};

export type ClientToServerEvents = {
  [SocketEvent.COACHING_CHAT_MESSAGE_STREAM]: (data: Conversation) => void;
};
